function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOops404ErrorwithabrokenrobotCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.64,317.14l-14.84.28-7.51.12c-2.51,0-5,0-7.55,0H62.3v-.45l0-12.63V304h.5l14.95.07c5,0,10,.11,15,.16h.27v.27c0,2.14-.09,4.27-.13,6.38Zm0,0-.15-6.37c0-2.1-.11-4.19-.13-6.26l.28.27c-5,.06-10,.16-15,.17L62.74,305l.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4.05l7.43.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,333.07l-14.83.28-7.52.12c-2.51,0-5,0-7.55,0h-.44v-.45l-.06-12.63v-.5h.5L61,320c5,0,10,.12,14.95.17h.27v.27c0,2.14-.08,4.27-.13,6.38Zm0,0-.14-6.37c0-2.1-.11-4.19-.13-6.26l.27.27c-5,.06-10,.16-14.95.17l-14.95.06.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4.05l7.44.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,59.71,61.13,60l-7.52.11c-2.51,0-5,0-7.55.06h-.44v-.45l-.06-12.63v-.5h.5L61,46.64c5,0,10,.12,14.95.17h.27v.27c0,2.14-.08,4.27-.13,6.38Zm0,0-.14-6.37c0-2.1-.11-4.19-.13-6.26l.27.27c-5,0-10,.16-14.95.17l-14.95.06.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4,0l7.44.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.94,59.71,439.1,60l-7.51.11c-2.51,0-5,0-7.55.06h-.44v-.45l0-12.63v-.5h.5l14.95.06c5,0,10,.12,14.95.17h.27v.27c0,2.14-.09,4.27-.13,6.38Zm0,0-.14-6.37c-.05-2.1-.12-4.19-.14-6.26l.28.27c-5,0-10,.16-14.95.17L424,47.58l.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4,0l7.43.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.26,75.64l-14.83.28-7.52.11c-2.51,0-5,0-7.55.06h-.44v-.45L406.86,63v-.5h.5l14.95.06c5,0,10,.12,14.95.17h.28V63c0,2.14-.08,4.27-.13,6.38Zm0,0-.14-6.37c-.05-2.11-.11-4.19-.13-6.26l.27.27c-5,0-10,.16-14.95.17l-14.95.06.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4,0l7.44.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69,223.44l-14.83.28-7.52.11c-2.51,0-5,0-7.54,0h-.45v-.45l-.05-12.64v-.5h.51l14.94.07c5,0,10,.11,14.95.16H361v.27c0,2.14-.08,4.27-.13,6.38Zm0,0-.14-6.38c-.05-2.1-.11-4.18-.13-6.26l.27.28c-5,0-10,.16-14.95.16l-14.94.06.49-.5-.05,12.64-.44-.45c2.46,0,4.92,0,7.39.06l7.44.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,239.37l-14.83.28-7.51.11c-2.51.05-5,0-7.55.05h-.45v-.45l-.05-12.64v-.5h.5l14.95.07c5,0,10,.11,14.94.16h.28v.27c0,2.14-.09,4.27-.13,6.38Zm0,0-.14-6.38c0-2.1-.11-4.18-.13-6.26l.27.28c-5,.05-10,.16-14.94.16l-14.95.06.5-.5-.06,12.64-.44-.45c2.46,0,4.93,0,7.4.06l7.43.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,223.44l-14.83.28-7.51.11c-2.51,0-5,0-7.55,0h-.45v-.45L297,210.8v-.5h.51l14.94.07c5,0,10,.11,14.95.16h.28v.27c0,2.14-.09,4.27-.13,6.38Zm0,0-.14-6.38c0-2.1-.11-4.18-.13-6.26l.27.28c-5,0-10,.16-14.95.16l-14.94.06.5-.5L298,223.44l-.44-.45c2.46,0,4.92,0,7.4.06l7.43.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.94,333.07l-14.84.28-7.51.12c-2.51,0-5,0-7.55,0h-.44v-.45l0-12.63v-.5h.5L439,320c5,0,10,.12,14.95.17h.27v.27c0,2.14-.09,4.27-.13,6.38Zm0,0-.14-6.37c-.05-2.1-.12-4.19-.14-6.26l.28.27c-5,.06-10,.16-14.95.17l-14.95.06.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4.05l7.43.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93,97.28l-14.84.28-7.51.11c-2.51,0-5,0-7.55.06h-.44v-.45l-.05-12.63v-.5h.5l14.95.06c5,0,10,.11,15,.17h.27v.27c0,2.14-.09,4.27-.13,6.37Zm0,0-.15-6.37c0-2.11-.11-4.19-.13-6.26l.28.27c-5,0-10,.16-15,.16L170,85.15l.5-.5-.05,12.63-.45-.44c2.47,0,4.93,0,7.4,0l7.43.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23,181l5.88-9.49-2.9-1.8a2.67,2.67,0,0,1-1.24-2.5,15.44,15.44,0,0,0,.06-1.67,2.65,2.65,0,0,1,1.38-2.41l3-1.61-5.28-9.85-3,1.62a2.66,2.66,0,0,1-2.77-.18,16,16,0,0,0-1.42-.88,2.66,2.66,0,0,1-1.4-2.41l.11-3.42L404.48,146l-.1,3.43a2.67,2.67,0,0,1-1.56,2.31c-.24.11-.49.24-.73.37s-.48.26-.71.4a2.65,2.65,0,0,1-2.78,0l-2.93-1.81-5.88,9.49,2.91,1.81a2.66,2.66,0,0,1,1.23,2.5,13.1,13.1,0,0,0-.05,1.66,2.68,2.68,0,0,1-1.39,2.41l-3,1.61,5.28,9.85,3-1.62a2.66,2.66,0,0,1,2.77.18,16,16,0,0,0,1.42.88,2.65,2.65,0,0,1,1.4,2.4l-.11,3.43,11.17.35.1-3.43a2.65,2.65,0,0,1,1.55-2.3l.74-.38c.25-.13.49-.26.72-.4a2.67,2.67,0,0,1,2.79,0Zm-9.46-7.05a9.14,9.14,0,1,1,3.75-12.38A9.14,9.14,0,0,1,413.77,173.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,288.51l5.89-9.49-2.91-1.8a2.66,2.66,0,0,1-1.23-2.5,15.45,15.45,0,0,0,0-1.67,2.66,2.66,0,0,1,1.39-2.41l3-1.61-5.28-9.85-3,1.62a2.68,2.68,0,0,1-2.78-.18,13.94,13.94,0,0,0-1.42-.88,2.68,2.68,0,0,1-1.4-2.41l.11-3.42-11.16-.35-.1,3.43a2.67,2.67,0,0,1-1.56,2.32c-.25.11-.49.24-.74.37s-.48.26-.71.4a2.63,2.63,0,0,1-2.77,0L74,258.29l-5.89,9.49L71,269.59a2.64,2.64,0,0,1,1.23,2.5c0,.55-.06,1.1,0,1.66a2.66,2.66,0,0,1-1.39,2.41l-3,1.61,5.28,9.85,3-1.62a2.68,2.68,0,0,1,2.78.18,13.71,13.71,0,0,0,1.41.87,2.68,2.68,0,0,1,1.4,2.41l-.1,3.43,11.16.34.11-3.42a2.66,2.66,0,0,1,1.55-2.31c.25-.11.49-.24.74-.37s.48-.26.71-.41a2.65,2.65,0,0,1,2.79,0Zm-9.45-7.05a9.15,9.15,0,1,1,3.74-12.38A9.14,9.14,0,0,1,92.08,281.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.87,106.74,212,100l-2.08,1.2a1.85,1.85,0,0,1-1.95-.07,11,11,0,0,0-1-.58,1.85,1.85,0,0,1-1-1.65v-2.4h-7.82v2.4a1.87,1.87,0,0,1-1,1.65c-.35.18-.69.37-1,.58a1.85,1.85,0,0,1-2,.07L192,100l-3.91,6.78,2.08,1.2a1.85,1.85,0,0,1,.91,1.72c0,.19,0,.39,0,.58s0,.38,0,.58a1.82,1.82,0,0,1-.9,1.71l-2.09,1.21,3.91,6.78,2.08-1.2a1.85,1.85,0,0,1,1.95.07,11,11,0,0,0,1,.58,1.87,1.87,0,0,1,1,1.65V124h7.82v-2.4a1.85,1.85,0,0,1,1-1.65c.35-.18.68-.37,1-.58a1.85,1.85,0,0,1,1.95-.07l2.08,1.2,3.91-6.78-2.08-1.2a1.85,1.85,0,0,1-.91-1.72c0-.19,0-.39,0-.58s0-.39,0-.58a1.85,1.85,0,0,1,.91-1.72Zm-7.48,3.5a6.41,6.41,0,1,1-6.41-6.41A6.41,6.41,0,0,1,208.39,110.24Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.84,303.84c-13.07,12.79-15.27,32.59-12.51,49.92.07.4.68.29.68-.08,0-3.95-.12-7.86-.11-11.76.07-.17.13-.34.2-.52,3.41-2.48,6.55-5.28,8.49-9.12,2.18-4.29,3-9.14,4.71-13.62.16-.43-.3-.3-.6-.08-8,5.86-10.48,12.17-12.76,20.6a69.79,69.79,0,0,1,1.38-13.13c1.72-8,5.11-15.93,10.86-21.86C89.4,304,89.06,303.61,88.84,303.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,305.33c2.25.08,3.66,3.67,5.41,4.72a1.68,1.68,0,0,0,2.48-.39c1.74-2.42-.64-5.41-2.88-7.09,1.6.66,2.93,1.82,4.65,2.15a1.64,1.64,0,0,0,2.11-1.26c.76-3.31-3.39-4.77-6.23-4.84,1.38-1,5.33-3.57,3.23-4.85s-6.76,2.44-8.27,3.67c-2.23,1.8-4.88,4.5-5,7.32C86.68,308.05,89.56,306,91.29,305.33Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,305.33c2.25.08,3.66,3.67,5.41,4.72a1.68,1.68,0,0,0,2.48-.39c1.74-2.42-.64-5.41-2.88-7.09,1.6.66,2.93,1.82,4.65,2.15a1.64,1.64,0,0,0,2.11-1.26c.76-3.31-3.39-4.77-6.23-4.84,1.38-1,5.33-3.57,3.23-4.85s-6.76,2.44-8.27,3.67c-2.23,1.8-4.88,4.5-5,7.32C86.68,308.05,89.56,306,91.29,305.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.64,305.89c2.88-1.31,8.4.57,8.87-.52.95-2.21-3.46-3.73-5.85-4,2.2-.59,6.4-1.54,6.27-3.65-.16-2.59-6.44-.36-9.63,2.08-4,3.07-4,6-3.32,6.63C87.89,307.22,90.17,306.1,90.64,305.89Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.07,302.57c13.55,12.29,16.49,32,14.4,49.42-.06.39-.67.31-.68-.06-.15-3.95-.18-7.86-.34-11.75-.08-.18-.15-.34-.22-.52-3.51-2.35-6.75-5-8.83-8.79-2.35-4.21-3.39-9-5.23-13.43-.17-.42.29-.32.6-.11,8.17,5.56,10.94,11.77,13.54,20.11a71.38,71.38,0,0,0-1.88-13.07c-2-7.93-5.72-15.72-11.69-21.44C58.52,302.71,58.84,302.36,59.07,302.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,304.16c-2.25.16-3.52,3.8-5.23,4.92a1.68,1.68,0,0,1-2.49-.3c-1.83-2.35.43-5.43,2.61-7.19-1.58.72-2.86,1.93-4.57,2.32a1.62,1.62,0,0,1-2.15-1.18c-.89-3.27,3.2-4.9,6-5.07-1.41-.91-5.46-3.36-3.41-4.72s6.85,2.18,8.41,3.35c2.29,1.71,5,4.31,5.25,7.12C61.38,306.7,58.43,304.78,56.68,304.16Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,304.16c-2.25.16-3.52,3.8-5.23,4.92a1.68,1.68,0,0,1-2.49-.3c-1.83-2.35.43-5.43,2.61-7.19-1.58.72-2.86,1.93-4.57,2.32a1.62,1.62,0,0,1-2.15-1.18c-.89-3.27,3.2-4.9,6-5.07-1.41-.91-5.46-3.36-3.41-4.72s6.85,2.18,8.41,3.35c2.29,1.71,5,4.31,5.25,7.12C61.38,306.7,58.43,304.78,56.68,304.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.35,304.69c-2.93-1.2-8.37.89-8.88-.18-1-2.18,3.31-3.86,5.68-4.25-2.21-.51-6.45-1.29-6.4-3.41.06-2.59,6.43-.61,9.7,1.71,4.13,2.92,4.21,5.88,3.57,6.5C60.15,305.91,57.83,304.88,57.35,304.69Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,335a132.49,132.49,0,0,0,4.2,19.42.49.49,0,0,0,1-.19c-.89-6-2.51-11.86-3.4-17.85a89.21,89.21,0,0,1-1-18.32c.57-10.09,3.31-20.83,9.89-28.72.14-.19-.16-.45-.31-.28C70,304.46,72.13,323.3,72.15,325c-1.87-6.36-3.79-13.65-10.85-20.13-.31-.28-.54-.15-.49.33,1.26,11.8,4.54,18,11.38,24.27C72.39,331.33,72.63,333.19,72.93,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.65,291.14c2.37-1.06,5.64,2,8,2.17A1.94,1.94,0,0,0,94,291.66c.59-3.39-3.39-5.3-6.56-5.9,2-.13,4,.41,5.92-.12a1.87,1.87,0,0,0,1.54-2.37C94,279.46,89,280,86,281.38c.94-1.69,3.73-6.38.91-6.65s-5.79,5.93-6.74,8c-1.4,3-2.79,7.12-1.48,10.09C80.23,296.27,82.2,292.72,83.65,291.14Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.65,291.14c2.37-1.06,5.64,2,8,2.17A1.94,1.94,0,0,0,94,291.66c.59-3.39-3.39-5.3-6.56-5.9,2-.13,4,.41,5.92-.12a1.87,1.87,0,0,0,1.54-2.37C94,279.46,89,280,86,281.38c.94-1.69,3.73-6.38.91-6.65s-5.79,5.93-6.74,8c-1.4,3-2.79,7.12-1.48,10.09C80.23,296.27,82.2,292.72,83.65,291.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25,292c2.33-2.8,9-3.63,8.94-5-.12-2.77-5.47-2.13-8.09-1.23,2-1.73,5.86-4.82,4.67-6.95-1.47-2.6-6.88,2.87-9,7-2.61,5.21-1.09,8.28-.1,8.56C81.07,294.81,82.87,292.5,83.25,292Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,338.58,58.44,383H93.81c-.72-3.93-7.31-44.46-7.31-44.46Z",
    style: {
      fill: "#EE384E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "43.37 383.14 95.03 382.9 146.69 382.81 250 382.64 353.31 382.81 404.97 382.9 456.63 383.14 404.97 383.39 353.31 383.48 250 383.64 146.69 383.48 95.03 383.39 43.37 383.14",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 449.04,
    rx: 149.06,
    ry: 21.08,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--404-error--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.57,227.67l-6.21-24.43-49,12.47-6.48-25.5L135,100.89,154.47,96l18.9,74.36,15.69-4L195.59,192l-15.69,4,6.2,24.43ZM124,182.87l24.26-6.17-8-31.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,146.12a65.58,65.58,0,0,1-3.68,22.35,55.48,55.48,0,0,1-10.12,17.67A45.82,45.82,0,0,1,269,197.73a43.91,43.91,0,0,1-19,4.14,44.54,44.54,0,0,1-19.14-4.14,45.75,45.75,0,0,1-15.27-11.59,54.17,54.17,0,0,1-10-17.67A66.82,66.82,0,0,1,202,146.12a66.84,66.84,0,0,1,3.59-22.36,54.22,54.22,0,0,1,10-17.66,46.68,46.68,0,0,1,15.27-11.68A43.74,43.74,0,0,1,250,90.19a43.12,43.12,0,0,1,19,4.23,46.76,46.76,0,0,1,15.18,11.68,55.54,55.54,0,0,1,10.12,17.66A65.6,65.6,0,0,1,298,146.12Zm-29.62,0q0-12.88-5.15-20.88t-13.25-8q-8.46,0-13.52,8t-5.06,20.88q0,12.88,5.06,20.79T250,174.82q8.1,0,13.25-7.91T268.4,146.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.84,223l4-24.88L304.93,190l4.21-26,71.5-66.33,19.8,3.21-12.27,75.74,16,2.59-4.23,26.15-16-2.59-4,24.88Zm-13-54.47,24.7,4,5.21-32.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.68,72.46A13,13,0,0,1,203,71.23a13.94,13.94,0,0,1-4.4-3.27,15.19,15.19,0,0,1-3.86-10,14.37,14.37,0,0,1,1.07-5.5,15.16,15.16,0,0,1,2.95-4.64,13.94,13.94,0,0,1,4.46-3.21,13.18,13.18,0,0,1,5.62-1.19,12.56,12.56,0,0,1,5.67,1.27A14.22,14.22,0,0,1,218.85,48a15.11,15.11,0,0,1,2.83,4.69,14.67,14.67,0,0,1,0,10.8,14.91,14.91,0,0,1-2.91,4.61,13.89,13.89,0,0,1-4.44,3.19A13.31,13.31,0,0,1,208.68,72.46Zm-8.33-14.54a11.38,11.38,0,0,0,.57,3.59,9.53,9.53,0,0,0,1.64,3.07,7.91,7.91,0,0,0,2.62,2.14,7.57,7.57,0,0,0,3.54.81,7.41,7.41,0,0,0,3.57-.83,8.1,8.1,0,0,0,2.63-2.2,9.68,9.68,0,0,0,1.61-3.09,11.31,11.31,0,0,0,0-7.09,10,10,0,0,0-1.65-3.07,8,8,0,0,0-2.63-2.12,8.16,8.16,0,0,0-7.09,0,8,8,0,0,0-2.63,2.18,9.85,9.85,0,0,0-1.59,3.07A11.63,11.63,0,0,0,200.35,57.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,72.66a11.48,11.48,0,0,1-4.65-.89,10.34,10.34,0,0,1-3.49-2.4,10.68,10.68,0,0,1-2.21-3.49,11.9,11.9,0,0,1,0-8.37A10.68,10.68,0,0,1,228.09,54a10.34,10.34,0,0,1,3.49-2.4,11.48,11.48,0,0,1,4.65-.89,11.33,11.33,0,0,1,4.62.89,10.36,10.36,0,0,1,3.47,2.4,10.68,10.68,0,0,1,2.21,3.49,11.9,11.9,0,0,1,0,8.37,10.94,10.94,0,0,1-2.18,3.49,10.3,10.3,0,0,1-3.48,2.4A11.46,11.46,0,0,1,236.23,72.66Zm-5.54-10.94a7.2,7.2,0,0,0,.43,2.56,6.2,6.2,0,0,0,1.17,2A5.1,5.1,0,0,0,234,67.59a5.31,5.31,0,0,0,4.37,0,5.1,5.1,0,0,0,1.75-1.31,6.4,6.4,0,0,0,1.18-2,7.61,7.61,0,0,0,.42-2.59,7.48,7.48,0,0,0-.42-2.54,6.4,6.4,0,0,0-1.18-2,5.1,5.1,0,0,0-1.75-1.31,5.17,5.17,0,0,0-2.18-.47,4.92,4.92,0,0,0-2.19.49,5.42,5.42,0,0,0-1.75,1.33,6.2,6.2,0,0,0-1.17,2A7.26,7.26,0,0,0,230.69,61.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.61,72.66a8.34,8.34,0,0,1-4.36-1.11,7.86,7.86,0,0,1-2.91-3V80.86h-5.41V51.09h4.73v3.64a8.58,8.58,0,0,1,3-2.93A8.42,8.42,0,0,1,263,50.73a9.1,9.1,0,0,1,4,.87,9.93,9.93,0,0,1,3.13,2.34,11,11,0,0,1,2.06,3.47,11.94,11.94,0,0,1,.74,4.22,13.59,13.59,0,0,1-.68,4.33,11.11,11.11,0,0,1-1.92,3.51,8.82,8.82,0,0,1-2.93,2.34A8.14,8.14,0,0,1,263.61,72.66Zm-1.81-4.6a4.89,4.89,0,0,0,2.24-.53,5.45,5.45,0,0,0,1.75-1.41,6.55,6.55,0,0,0,1.14-2.06,7.37,7.37,0,0,0,.4-2.43,7,7,0,0,0-.44-2.48,6.19,6.19,0,0,0-1.24-2,5.65,5.65,0,0,0-1.86-1.33,5.42,5.42,0,0,0-2.32-.49,4.94,4.94,0,0,0-1.57.27,5.52,5.52,0,0,0-1.5.74,6.61,6.61,0,0,0-1.23,1.13,4.85,4.85,0,0,0-.83,1.42v5a7.34,7.34,0,0,0,2.22,3A5.13,5.13,0,0,0,261.8,68.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.54,72.66a16.21,16.21,0,0,1-5.21-.85A12.69,12.69,0,0,1,275,69.39L277,66a17.91,17.91,0,0,0,3.78,2.08,10.19,10.19,0,0,0,3.66.7,4.66,4.66,0,0,0,2.54-.6,2,2,0,0,0,.93-1.74,1.73,1.73,0,0,0-1.09-1.65,23.75,23.75,0,0,0-3.55-1.22c-1.38-.37-2.55-.74-3.52-1.09a8.78,8.78,0,0,1-2.34-1.19,4,4,0,0,1-1.29-1.53,4.91,4.91,0,0,1-.41-2.08,6.54,6.54,0,0,1,.63-2.91,6.26,6.26,0,0,1,1.76-2.2,8.13,8.13,0,0,1,2.64-1.4,10.86,10.86,0,0,1,3.29-.48,14.43,14.43,0,0,1,4.47.68,10.79,10.79,0,0,1,3.81,2.23l-2.18,3.27A12.59,12.59,0,0,0,287,55.09a8.49,8.49,0,0,0-3-.57,4.33,4.33,0,0,0-2.3.57,2,2,0,0,0-.93,1.82,1.85,1.85,0,0,0,.22.93,1.94,1.94,0,0,0,.71.64,7.15,7.15,0,0,0,1.27.55c.53.17,1.18.36,2,.54,1.46.38,2.7.76,3.74,1.14A9.69,9.69,0,0,1,291.18,62a4.59,4.59,0,0,1,1.46,1.67A5.2,5.2,0,0,1,293.1,66a5.91,5.91,0,0,1-2.3,4.91A10,10,0,0,1,284.54,72.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.67,61.47V43.29h5.41V61.47Zm0,10.79v-6.1h5.41v6.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 313.85,
    width: 35.51,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 317.63,
    width: 35.51,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 321.42,
    width: 35.51,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 325.21,
    width: 35.51,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 329,
    width: 35.51,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.46,
    y: 404.59,
    width: 67.52,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.46,
    y: 408.38,
    width: 67.52,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.46,
    y: 412.17,
    width: 67.52,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.46,
    y: 415.96,
    width: 67.52,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.46,
    y: 419.75,
    width: 67.52,
    height: 2.91,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.83,289.8c0-.39-14.77-5.36-14.77-5.36l.87-50.88,19.64-4.22Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.83,289.8c0-.39-14.77-5.36-14.77-5.36l.87-50.88,19.64-4.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,309.77c.1-.38,15.72.06,15.72.06l16.69-48.08-17-10.71Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,309.77c.1-.38,15.72.06,15.72.06l16.69-48.08-17-10.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,308.54s5.49-82.3,10.31-109.38c0,0,99.42,7.52,153.09,28,0,0-27.67,96.12-29.1,100.89C320.28,328.09,250.27,314.3,186,308.54Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.72,210.15q-2.42,14.86-4.94,29.72l-5.13,29.67-.27-.41L297.69,277l16.64,4,16.61,4.11-16.7-3.74-16.69-3.81-33.34-7.79-.34-.08.06-.34,5.31-29.65Q271.91,225,274.72,210.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.07,215.8a2,2,0,0,1-1.75,1.94,2,2,0,0,1-1.46-.48,2,2,0,0,1-.66-1.46,2,2,0,0,1,.66-1.46,1.94,1.94,0,0,1,3.21,1.46Zm0,0a1.6,1.6,0,0,0-.55-1.19,1.57,1.57,0,1,0,0,2.39A1.64,1.64,0,0,0,271.07,215.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.32,228.05a1.93,1.93,0,0,1-1.74,1.93,1.92,1.92,0,0,1-2.12-1.93,1.94,1.94,0,0,1,.65-1.46,2,2,0,0,1,1.47-.48A2,2,0,0,1,269.32,228.05Zm0,0a1.6,1.6,0,0,0-.55-1.2,1.57,1.57,0,0,0-1.19-.36,1.57,1.57,0,0,0,0,3.12,1.56,1.56,0,0,0,1.74-1.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17,241a1.93,1.93,0,0,1-1.74,1.93,2,2,0,0,1-1.47-3.4,2,2,0,0,1,1.47-.47A1.94,1.94,0,0,1,267.17,241Zm0,0a1.6,1.6,0,0,0-.55-1.2,1.57,1.57,0,0,0-1.19-.36,1.57,1.57,0,0,0,0,3.12,1.62,1.62,0,0,0,1.19-.37A1.56,1.56,0,0,0,267.17,241Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,253.93a1.94,1.94,0,0,1-1.74,1.93,1.94,1.94,0,1,1,0-3.87A1.94,1.94,0,0,1,265,253.93Zm0,0a1.6,1.6,0,0,0-.55-1.2,1.57,1.57,0,0,0-1.19-.36,1.57,1.57,0,0,0,0,3.12,1.62,1.62,0,0,0,1.19-.37A1.6,1.6,0,0,0,265,253.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,274.56a1.94,1.94,0,1,1-1.75-1.93A1.94,1.94,0,0,1,272.35,274.56Zm0,0a1.64,1.64,0,0,0-.55-1.2,1.62,1.62,0,0,0-1.2-.36,1.57,1.57,0,1,0,1.2,2.76A1.64,1.64,0,0,0,272.35,274.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.56,277.54a1.94,1.94,0,0,1-3.21,1.46,1.94,1.94,0,0,1,0-2.92,2,2,0,0,1,1.46-.47A1.93,1.93,0,0,1,284.56,277.54Zm0,0a1.6,1.6,0,0,0-.55-1.2,1.62,1.62,0,0,0-1.2-.36,1.57,1.57,0,1,0,1.2,2.76A1.6,1.6,0,0,0,284.56,277.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77,280.52a1.93,1.93,0,0,1-3.2,1.46,2,2,0,0,1-.66-1.46,1.94,1.94,0,0,1,.65-1.46,2,2,0,0,1,1.47-.47A1.93,1.93,0,0,1,296.77,280.52Zm0,0a1.59,1.59,0,0,0-.54-1.2A1.64,1.64,0,0,0,295,279a1.57,1.57,0,0,0,0,3.12,1.63,1.63,0,0,0,1.2-.36A1.59,1.59,0,0,0,296.77,280.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,283.5a1.94,1.94,0,0,1-3.21,1.46,2,2,0,0,1-.66-1.46,2,2,0,0,1,.66-1.46,2,2,0,0,1,1.46-.48A2,2,0,0,1,309,283.5Zm0,0a1.64,1.64,0,0,0-.55-1.2,1.57,1.57,0,1,0-1.2,2.76,1.62,1.62,0,0,0,1.2-.36A1.64,1.64,0,0,0,309,283.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.2,286.61a2,2,0,0,1-1.89,1.79,2,2,0,0,1-1.43-.58,1.95,1.95,0,0,1,.23-2.91,1.92,1.92,0,0,1,1.49-.36A2,2,0,0,1,321.2,286.61Zm0,0a1.6,1.6,0,0,0-.46-1.23,1.57,1.57,0,1,0-.18,2.38A1.6,1.6,0,0,0,321.2,286.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.87,266.86a1.94,1.94,0,0,1-1.74,1.94,2.05,2.05,0,0,1-1.47-.47,1.94,1.94,0,0,1,1.47-3.4A1.94,1.94,0,0,1,262.87,266.86Zm0,0a1.6,1.6,0,0,0-.55-1.19,1.57,1.57,0,1,0,0,2.39A1.6,1.6,0,0,0,262.87,266.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.43,
    cy: 267.31,
    r: 28.23,
    transform: "translate(-121.44 217.93) rotate(-41.96)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.43,
    cy: 267.31,
    r: 22.64,
    transform: "translate(-105.66 381.64) rotate(-69.27)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.31,
    y: 258.54,
    width: 5.36,
    height: 5.36,
    transform: "translate(44.59 -31.66) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.87,
    y: 252.39,
    width: 5.36,
    height: 5.36,
    transform: "translate(43.55 -31.03) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.04,
    y: 255.82,
    width: 5.36,
    height: 5.36,
    transform: "translate(44.37 -34.37) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.46,
    y: 273.44,
    width: 5.36,
    height: 5.36,
    transform: "translate(46.87 -30.21) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.63,
    y: 276.87,
    width: 5.36,
    height: 5.36,
    transform: "translate(47.7 -33.55) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.61,
    y: 269,
    width: 5.36,
    height: 5.36,
    transform: "translate(46.24 -31.25) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.75,
    y: 264.63,
    width: 5.36,
    height: 5.36,
    transform: "translate(45.62 -32.29) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.89,
    y: 260.25,
    width: 5.36,
    height: 5.36,
    transform: "translate(45 -33.33) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.2,
    y: 270.72,
    width: 5.36,
    height: 5.36,
    transform: "translate(46.66 -32.93) rotate(9.2)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.19,
    cy: 279.14,
    r: 28.23,
    transform: "translate(-106.35 333.63) rotate(-50.67)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.19,
    cy: 279.14,
    r: 28.23,
    transform: "translate(-106.35 333.63) rotate(-50.67)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.66,285.67c-.13.56-.28,1.09-.44,1.63l-55-11.74c.13-1,.3-2,.53-2.95a28.24,28.24,0,1,1,54.94,13.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.19,
    cy: 279.14,
    r: 22.64,
    transform: "translate(-84.49 136.92) rotate(-22.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.51,
    y: 265.8,
    width: 5.36,
    height: 26.69,
    transform: "translate(72.65 -61.61) rotate(13.37)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3,285.14,270.5,271.4a29.71,29.71,0,0,1,57.8,13.74Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3,285.14,270.5,271.4a29.71,29.71,0,0,1,57.8,13.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07,295.92a10.51,10.51,0,0,1,2.61-6.35,7.67,7.67,0,0,1,3.07-2.07,8.66,8.66,0,0,1,3.7-.41,6.9,6.9,0,0,1,5.8,4.33,11.49,11.49,0,0,1,.59,6.85,18,18,0,0,0-2-6.14,5.88,5.88,0,0,0-4.61-3.06,7.06,7.06,0,0,0-5.49,1.61A14.78,14.78,0,0,0,250.07,295.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72,238.34c.23-3,.57-6,.86-9s.65-6,1-9,.74-6,1.12-9,.81-6,1.22-9l.1-.8.81.05q9.78.61,19.51,1.61c3.24.33,6.48.71,9.72,1.12s6.47.9,9.68,1.48l-19.52-1.2-19.49-1.27.91-.74c-.44,3-.85,6-1.32,9s-.92,6-1.42,8.95-1,5.95-1.52,8.93S194.33,235.38,193.72,238.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.41,261.16a24.55,24.55,0,0,1,4.52-10.09c.55-.76,1.18-1.46,1.78-2.18s1.33-1.33,2-2,1.47-1.18,2.22-1.75,1.58-1,2.39-1.52,1.71-.83,2.57-1.22l2.68-.93,2.78-.57c.93-.14,1.87-.17,2.81-.24A27.3,27.3,0,0,1,233,242.76a38.59,38.59,0,0,0-10.78-.72,25.22,25.22,0,0,0-10.07,3.13,29.14,29.14,0,0,0-8.18,6.75A33.21,33.21,0,0,0,198.41,261.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.29,268.78a24.78,24.78,0,0,1,5.86-9.37c.65-.67,1.37-1.28,2.07-1.91s1.5-1.13,2.26-1.69,1.61-1,2.44-1.43,1.71-.8,2.58-1.17,1.8-.59,2.7-.86l2.79-.55,2.83-.18c.94,0,1.88.1,2.82.16a27.19,27.19,0,0,1,10.47,3.56,38.91,38.91,0,0,0-10.58-2.2,25.25,25.25,0,0,0-10.4,1.71,29.45,29.45,0,0,0-9,5.55A33.57,33.57,0,0,0,276.29,268.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14,359.25c-7.23,0-23.06-1.62-33.25-14.72-13-16.76-8.32-48.92-8.12-50.28l5.66.86c0,.31-4.54,31.09,7,45.9,11.26,14.48,31.69,12.41,31.89,12.38l.65,5.69C192.72,359.1,191.32,359.25,189.14,359.25Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14,359.25c-7.23,0-23.06-1.62-33.25-14.72-13-16.76-8.32-48.92-8.12-50.28l5.66.86c0,.31-4.54,31.09,7,45.9,11.26,14.48,31.69,12.41,31.89,12.38l.65,5.69C192.72,359.1,191.32,359.25,189.14,359.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1,299a19,19,0,0,1-3.16-.25c-9.55-1.55-13.77-7.26-15.64-11.78S134,277,135,270.68l12.1,2c-.63,3.89-.44,7.32.52,9.65.69,1.66,2,3.66,6.26,4.35,1.94.31,4,.15,6.23-3.16a22.84,22.84,0,0,0,3.06-8.23l12.11,2a35.47,35.47,0,0,1-5,13C166.56,296,161.22,299,155.1,299Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1,375.63c0-.26-10.26-1.89-10.26-1.89l-5-33.41,12.39-4.9Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1,375.63c0-.26-10.26-1.89-10.26-1.89l-5-33.41,12.39-4.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,375.69c0-.26,10.29-1.66,10.29-1.66l5.71-33.29L306,335.57Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,375.69c0-.26,10.29-1.66,10.29-1.66l5.71-33.29L306,335.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84,328s82.79-3.53,110.75,1.13c0,0-8.21,80.1-8.65,81.66,0,0-82.36-.23-95.23,0C203.71,410.74,196.74,357.47,196.84,328Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,349.91s45.19-1.79,60.46.56c0,0-4.49,40.39-4.73,41.18,0,0-45-.11-52,0C225.74,391.65,222.65,364,222,349.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.16,391.63l-2.43,0S222.65,364,222,349.9l2.83-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.49,359.87a4.81,4.81,0,1,0,3.14,6A4.81,4.81,0,0,0,241.49,359.87Zm2.58,5.86a4.22,4.22,0,1,1-2.75-5.3A4.22,4.22,0,0,1,244.07,365.73Zm-2.58-5.86a4.81,4.81,0,1,0,3.14,6A4.81,4.81,0,0,0,241.49,359.87Zm2.58,5.86a4.22,4.22,0,1,1-2.75-5.3A4.22,4.22,0,0,1,244.07,365.73Zm-2.58-5.86a4.81,4.81,0,1,0,3.14,6A4.81,4.81,0,0,0,241.49,359.87Zm2.58,5.86a4.22,4.22,0,1,1-2.75-5.3A4.22,4.22,0,0,1,244.07,365.73Zm-1-10.94a10.13,10.13,0,1,0,6.61,12.71A10.14,10.14,0,0,0,243.1,354.79Zm2.25,11.34a5.56,5.56,0,1,1-3.63-7A5.57,5.57,0,0,1,245.35,366.13Zm-.72-.23a4.81,4.81,0,1,0-6,3.14A4.8,4.8,0,0,0,244.63,365.9Zm-.56-.17a4.22,4.22,0,1,1-2.75-5.3A4.22,4.22,0,0,1,244.07,365.73Zm-2.58-5.86a4.81,4.81,0,1,0,3.14,6A4.81,4.81,0,0,0,241.49,359.87Zm2.58,5.86a4.22,4.22,0,1,1-2.75-5.3A4.22,4.22,0,0,1,244.07,365.73Zm-2.58-5.86a4.81,4.81,0,1,0,3.14,6A4.81,4.81,0,0,0,241.49,359.87Zm2.58,5.86a4.22,4.22,0,1,1-2.75-5.3A4.22,4.22,0,0,1,244.07,365.73Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.99 374.31 235.27 373.13 234.65 375.83 237.95 376.87 238.99 374.31",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.31 370.82 230.51 367.37 228.16 368.83 229.76 371.91 232.31 370.82",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.05 363.64 231.22 359.93 228.53 359.3 227.48 362.61 230.05 363.64",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.53 356.96 236.99 355.17 235.52 352.82 232.45 354.42 233.53 356.96",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.71 354.7 244.43 355.88 245.05 353.18 241.75 352.14 240.71 354.7",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.39 358.18 249.19 361.64 251.54 360.18 249.94 357.1 247.39 358.18",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.65 365.37 248.48 369.08 251.18 369.71 252.22 366.4 249.65 365.37",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.17 372.04 242.72 373.84 244.18 376.19 247.25 374.59 246.17 372.04",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.84,374a3.24,3.24,0,1,0,.94,4.48A3.24,3.24,0,0,0,257.84,374Zm.61,4.26a2.84,2.84,0,1,1-.83-3.93A2.84,2.84,0,0,1,258.45,378.27Zm-.61-4.26a3.24,3.24,0,1,0,.94,4.48A3.24,3.24,0,0,0,257.84,374Zm.61,4.26a2.84,2.84,0,1,1-.83-3.93A2.84,2.84,0,0,1,258.45,378.27Zm-.61-4.26a3.24,3.24,0,1,0,.94,4.48A3.24,3.24,0,0,0,257.84,374Zm.61,4.26a2.84,2.84,0,1,1-.83-3.93A2.84,2.84,0,0,1,258.45,378.27Zm1.34-7.26a6.82,6.82,0,1,0,2,9.44A6.82,6.82,0,0,0,259.79,371Zm-.59,7.75a3.74,3.74,0,1,1-1.09-5.17A3.74,3.74,0,0,1,259.2,378.76Zm-.42-.27a3.23,3.23,0,1,0-4.48.95A3.25,3.25,0,0,0,258.78,378.49Zm-.33-.22a2.84,2.84,0,1,1-.83-3.93A2.84,2.84,0,0,1,258.45,378.27Zm-.61-4.26a3.24,3.24,0,1,0,.94,4.48A3.24,3.24,0,0,0,257.84,374Zm.61,4.26a2.84,2.84,0,1,1-.83-3.93A2.84,2.84,0,0,1,258.45,378.27Zm-.61-4.26a3.24,3.24,0,1,0,.94,4.48A3.24,3.24,0,0,0,257.84,374Zm.61,4.26a2.84,2.84,0,1,1-.83-3.93A2.84,2.84,0,0,1,258.45,378.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.6 382.92 251.4 381.49 250.51 383.12 252.47 384.39 253.6 382.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.9 379.45 249.36 376.89 247.57 377.41 248.05 379.7 249.9 379.45",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.73 374.39 251.16 372.19 249.53 371.3 248.25 373.25 249.73 374.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.2 370.69 255.76 370.14 255.24 368.36 252.95 368.84 253.2 370.69",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.26 370.52 260.46 371.95 261.35 370.31 259.4 369.04 258.26 370.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.96 373.98 262.51 376.55 264.29 376.02 263.81 373.74 261.96 373.98",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.13 379.05 260.7 381.25 262.33 382.14 263.61 380.18 262.13 379.05",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.67 382.75 256.1 383.29 256.63 385.08 258.91 384.6 258.67 382.75",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.59 401.41 308.78 402.01 317.88 340.38 314.25 339.71 305.59 401.41",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,391.65l4.73-41.18,31.8-10.76s-8.66,62.37-8.66,61.7Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,391.65l4.73-41.18,31.8-10.76s-8.66,62.37-8.66,61.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,352.14c-.52-3.41-.8-6.85-1-10.29-.1-1.72-.14-3.45-.18-5.17s-.06-3.45,0-5.18v-.45l.44,0c6.32-.34,12.63-.76,19-1s12.64-.6,19-.8c-6.31.57-12.61,1.06-18.92,1.52s-12.63.84-18.94,1.27l.46-.47,0,5.15.06,5.15c0,1.72,0,3.44.09,5.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,351.08q3-1.41,6-2.61t6.12-2.32c2.06-.7,4.13-1.39,6.24-2a57.54,57.54,0,0,1,6.39-1.49l.53-.09-.09.51c-.5,2.67-1,5.33-1.64,8,.23-2.71.56-5.41.9-8.1l.44.43c-2.1.5-4.18,1.08-6.26,1.7s-4.15,1.27-6.21,1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.4 328.12 214.94 338.42 215.4 348.72 216.19 369.33 216.81 389.94 217.06 400.25 217.23 410.57 216.69 400.27 216.24 389.96 215.44 369.36 214.82 348.74 214.57 338.43 214.4 328.12",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.45,334.33a1.93,1.93,0,0,1-2.85,2.07,2,2,0,0,1-.94-1.31,2,2,0,0,1,.36-1.56,2,2,0,0,1,1.34-.75A1.94,1.94,0,0,1,211.45,334.33Zm0,0a1.56,1.56,0,1,0-.3,1.28A1.56,1.56,0,0,0,211.45,334.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,346.68a2,2,0,0,1-1.33,2.24,1.93,1.93,0,0,1-2.46-1.48,2,2,0,0,1,.36-1.56,2,2,0,0,1,1.34-.75A1.94,1.94,0,0,1,212.16,346.68Zm0,0a1.54,1.54,0,0,0-2-1.18,1.57,1.57,0,1,0,2,1.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,359.79a2,2,0,0,1-1.33,2.24,2,2,0,0,1-1.52-.17,2,2,0,0,1-.94-1.31,2,2,0,0,1,.36-1.56,1.93,1.93,0,0,1,3.43.8Zm0,0a1.54,1.54,0,0,0-2-1.18,1.57,1.57,0,1,0,2,1.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.06,372.9a2,2,0,0,1-1.33,2.24,2,2,0,0,1-2.46-1.48,2,2,0,0,1,.36-1.56,1.93,1.93,0,0,1,3.43.8Zm0,0a1.6,1.6,0,0,0-.77-1.07,1.66,1.66,0,0,0-1.25-.12,1.57,1.57,0,0,0,.62,3.06,1.61,1.61,0,0,0,1.1-.59A1.58,1.58,0,0,0,213.06,372.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,386a1.93,1.93,0,0,1-2.85,2.07,2,2,0,0,1-.94-1.3,2,2,0,0,1,.36-1.57,2,2,0,0,1,1.34-.75A2,2,0,0,1,213.51,386Zm0,0a1.56,1.56,0,0,0-2-1.18,1.57,1.57,0,0,0,.62,3.06,1.56,1.56,0,0,0,1.4-1.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,399.11a1.93,1.93,0,1,1-3.79.77,1.94,1.94,0,0,1,1.7-2.32A2,2,0,0,1,214,399.11Zm0,0a1.58,1.58,0,0,0-.77-1.06,1.62,1.62,0,0,0-1.25-.12,1.57,1.57,0,0,0,.62,3.06,1.56,1.56,0,0,0,1.4-1.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.93,
    y: 426.13,
    width: 48.98,
    height: 5.72,
    transform: "translate(-116.03 75.12) rotate(-16.86)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.93,
    y: 426.13,
    width: 48.98,
    height: 5.72,
    transform: "translate(-116.03 75.12) rotate(-16.86)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.27,
    y: 424.75,
    width: 5.72,
    height: 8.5,
    transform: "translate(-120.89 79.02) rotate(-17.64)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.43 446.86 160.33 394.48 123.82 403.14 141.8 454.19 172.43 446.86",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.53 444.2 172.43 446.86 160.33 394.48 171.98 397.26 180.53 444.2",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.53 444.2 172.43 446.86 160.33 394.48 171.98 397.26 180.53 444.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.86,
    cy: 421.89,
    r: 6.21,
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.54,
    y: 404.41,
    width: 5.72,
    height: 48.98,
    transform: "translate(-193.99 595.74) rotate(-73.02)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.54,
    y: 404.41,
    width: 5.72,
    height: 48.98,
    transform: "translate(-193.99 595.74) rotate(-73.02)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.44,
    y: 426.04,
    width: 8.5,
    height: 5.72,
    transform: "translate(-195.36 590.05) rotate(-72.23)",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.36 446.82 340.56 394.46 377.06 403.2 358.97 454.21 328.36 446.82",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.26 444.14 328.36 446.82 340.56 394.46 328.91 397.21 320.26 444.14",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.26 444.14 328.36 446.82 340.56 394.46 328.91 397.21 320.26 444.14",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.76,421.74a6.22,6.22,0,1,0,6.23-6.2A6.21,6.21,0,0,0,275.76,421.74Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.66,357.13c.15-.14,15.21-14.1,32.92-9.32,18.11,4.88,33.06,32.16,33.21,32.44l5-2.72c-.66-1.21-16.26-29.73-36.76-35.25-20.86-5.62-37.65,10-38.35,10.7Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.66,357.13c.15-.14,15.21-14.1,32.92-9.32,18.11,4.88,33.06,32.16,33.21,32.44l5-2.72c-.66-1.21-16.26-29.73-36.76-35.25-20.86-5.62-37.65,10-38.35,10.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.12,407.71,393,402a23,23,0,0,1-2.51-8.42c-.24-4,1.34-5.36,3.07-6.28,3.8-2,6.07-1.21,7.62-.3,2.17,1.29,4.38,3.91,6.22,7.4l10.85-5.73c-3-5.62-6.62-9.74-10.84-12.23s-11-4.5-19.57,0c-6.67,3.52-10.07,9.86-9.59,17.86A35.5,35.5,0,0,0,382.12,407.71Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,338c2.35-1.62,4.76-3.15,7.17-4.67s4.86-3,7.31-4.44,4.92-2.87,7.42-4.24l3.76-2.05c1.27-.65,2.52-1.33,3.81-2-1.17.82-2.38,1.59-3.56,2.38l-3.62,2.29c-2.41,1.53-4.85,3-7.3,4.44s-4.93,2.87-7.43,4.24S327.51,336.75,325,338Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,361.42c3.37,1.92,6.56,4.09,9.71,6.31s6.21,4.56,9.12,7.12a115.22,115.22,0,0,1-9.71-6.31C324.72,366.29,321.63,364,318.72,361.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.25,358.54c2.6.79,5.16,1.69,7.71,2.59S337,363,339.57,364s5,2,7.52,3l3.74,1.6c1.23.57,2.47,1.11,3.69,1.7-1.3-.38-2.58-.83-3.87-1.24l-3.83-1.34c-2.56-.9-5.09-1.87-7.61-2.84s-5-2-7.53-3S326.7,359.72,324.25,358.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,340.22c2.49-.65,5-1.19,7.51-1.71s5-1,7.56-1.45,5.05-.86,7.59-1.22l3.81-.53c1.28-.14,2.55-.31,3.84-.42-1.25.33-2.5.6-3.75.91l-3.76.8c-2.51.53-5,1-7.56,1.45s-5.06.86-7.6,1.21S334.19,340,331.63,340.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.62,355.79a26.61,26.61,0,0,1,2-5.88,23.77,23.77,0,0,1,3.31-5.28,12.8,12.8,0,0,1,5-3.75,8.85,8.85,0,0,1,6.31.06,8.4,8.4,0,0,1,4.51,4.47,9.83,9.83,0,0,1,.84,3.11,7,7,0,0,1-.37,3.27,2.94,2.94,0,0,1-1.1,1.41,2.14,2.14,0,0,1-.91.34,2,2,0,0,1-1-.09,2.81,2.81,0,0,1-1.29-1.31,7.28,7.28,0,0,1-.59-1.54,20.11,20.11,0,0,1-.52-6.31,25.87,25.87,0,0,1,3.64-12,15.64,15.64,0,0,1,4.34-4.61,13.14,13.14,0,0,1,5.89-2.28,16.51,16.51,0,0,1,3.14-.27,9.25,9.25,0,0,1,1.58.1,10.26,10.26,0,0,1,1.56.21,19.16,19.16,0,0,1,5.86,2.21,24.69,24.69,0,0,1,4.9,3.85,26.13,26.13,0,0,1,3.86,4.85,27,27,0,0,0-9-8.27,18.75,18.75,0,0,0-5.73-2,20.94,20.94,0,0,0-3-.23,15.94,15.94,0,0,0-3,.33,13,13,0,0,0-5.53,2.23,14.65,14.65,0,0,0-4.06,4.38,25,25,0,0,0-3.43,11.54,19.31,19.31,0,0,0,.45,6c.24.92.67,2,1.3,2.24a1.32,1.32,0,0,0,.23.05,1,1,0,0,0,.3,0,1.25,1.25,0,0,0,.53-.19,2.08,2.08,0,0,0,.76-1,6,6,0,0,0,.33-2.83,9.38,9.38,0,0,0-.75-2.85,7.82,7.82,0,0,0-4-4.11,8.16,8.16,0,0,0-5.8-.18,12.46,12.46,0,0,0-4.88,3.48A27,27,0,0,0,271.62,355.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,381.7a14,14,0,0,1,4-4.63,15,15,0,0,1,5.6-2.69,12.05,12.05,0,0,1,6.25.13,12.48,12.48,0,0,1,5.34,3.32,15.79,15.79,0,0,1,3.34,5.33,14.64,14.64,0,0,1,1,6.23,5.24,5.24,0,0,1-1.16,3.12,2.44,2.44,0,0,1-1.69.76,3.7,3.7,0,0,1-1.72-.39,2.83,2.83,0,0,1-1.24-1.32,4.37,4.37,0,0,1-.38-1.68,9.17,9.17,0,0,1,.53-3.19,18.58,18.58,0,0,1,3.06-5.51,22,22,0,0,1,4.53-4.35,16.9,16.9,0,0,1,11.92-3.28,16,16,0,0,1,5.95,1.94,16.39,16.39,0,0,1,4.73,4.07,22.32,22.32,0,0,1,3.08,5.38,25.27,25.27,0,0,1,1.64,5.95,25,25,0,0,0-5.12-11,15.51,15.51,0,0,0-4.64-3.82,15.23,15.23,0,0,0-5.73-1.72,16.27,16.27,0,0,0-11.29,3.22,20.52,20.52,0,0,0-7.19,9.43,8.13,8.13,0,0,0-.51,2.85,2.42,2.42,0,0,0,1.1,2.2,2.53,2.53,0,0,0,1.25.29,1.49,1.49,0,0,0,1.06-.47,4.36,4.36,0,0,0,.92-2.56,13.7,13.7,0,0,0-1-5.84,15.56,15.56,0,0,0-3.12-5.08,11.8,11.8,0,0,0-5-3.22,11.43,11.43,0,0,0-5.92-.26A15.39,15.39,0,0,0,179.22,381.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,140.21a26.83,26.83,0,0,0-2.9-11.87,12.38,12.38,0,0,0-3.9-4.55,8.21,8.21,0,0,0-5.68-1.21,7.77,7.77,0,0,0-4.87,3,9,9,0,0,0-1.41,2.58,6,6,0,0,0-.36,2.83,2.1,2.1,0,0,0,.5,1.14,1.23,1.23,0,0,0,.47.32,1.57,1.57,0,0,0,.29.08,1.92,1.92,0,0,0,.24,0c.68-.13,1.35-1,1.8-1.86A19.62,19.62,0,0,0,119,125a25.06,25.06,0,0,0-.57-12,14.76,14.76,0,0,0-2.9-5.23,12.94,12.94,0,0,0-4.84-3.48,15.83,15.83,0,0,0-2.84-1,19.17,19.17,0,0,0-3-.5,18.38,18.38,0,0,0-6,.6,26.77,26.77,0,0,0-10.72,5.88,25.89,25.89,0,0,1,4.91-3.8,24.76,24.76,0,0,1,5.67-2.56,19.17,19.17,0,0,1,6.22-.75,22.84,22.84,0,0,1,3.12.45,17.14,17.14,0,0,1,3,1,13.2,13.2,0,0,1,5.18,3.62,15.53,15.53,0,0,1,3.11,5.51,25.92,25.92,0,0,1,.69,12.49,20.32,20.32,0,0,1-2,6,7.61,7.61,0,0,1-.94,1.35,2.81,2.81,0,0,1-1.57,1,2.11,2.11,0,0,1-1-.15,2.14,2.14,0,0,1-.79-.54,3.05,3.05,0,0,1-.74-1.64,7,7,0,0,1,.42-3.26,10,10,0,0,1,1.57-2.82,8.38,8.38,0,0,1,5.44-3.27,8.88,8.88,0,0,1,6.14,1.45,12.77,12.77,0,0,1,4,4.84,23.63,23.63,0,0,1,2,5.92A26.22,26.22,0,0,1,133,140.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,192.37a27,27,0,0,0-12.22,0,12.4,12.4,0,0,0-5.33,2.74,8.09,8.09,0,0,0-2.5,5.23,7.8,7.8,0,0,0,1.81,5.45,9.17,9.17,0,0,0,2.19,2,6.12,6.12,0,0,0,2.66,1,2.15,2.15,0,0,0,1.23-.23,1.19,1.19,0,0,0,.42-.38c.06-.07.09-.18.15-.26s0-.16.05-.23c0-.69-.68-1.55-1.39-2.19a19.79,19.79,0,0,0-5.12-3.14,25,25,0,0,0-11.82-2.25,14.76,14.76,0,0,0-5.76,1.6,12.88,12.88,0,0,0-4.51,3.89,16.25,16.25,0,0,0-1.68,2.52,9.62,9.62,0,0,0-.64,1.38,9.3,9.3,0,0,0-.54,1.41,18.53,18.53,0,0,0-.83,6,26.82,26.82,0,0,0,3.22,11.79,25.89,25.89,0,0,1-2.55-5.65,24.89,24.89,0,0,1-1.16-6.12,19.27,19.27,0,0,1,.71-6.22,11.49,11.49,0,0,1,.53-1.49,10.88,10.88,0,0,1,.64-1.44,16.42,16.42,0,0,1,1.68-2.67,13.26,13.26,0,0,1,4.73-4.19,15.81,15.81,0,0,1,6.08-1.74,25.86,25.86,0,0,1,12.3,2.25,20.31,20.31,0,0,1,5.37,3.35,8.11,8.11,0,0,1,1.1,1.23,2.84,2.84,0,0,1,.57,1.75,2,2,0,0,1-.37.93,2.14,2.14,0,0,1-.72.65,3,3,0,0,1-1.76.33,6.91,6.91,0,0,1-3.07-1.17,10.09,10.09,0,0,1-2.38-2.18,8.41,8.41,0,0,1-1.91-6,8.88,8.88,0,0,1,2.84-5.64,13,13,0,0,1,5.64-2.74,23.64,23.64,0,0,1,6.21-.51A27,27,0,0,1,353.77,192.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,127.67a17,17,0,0,1-.39-7.35,17.89,17.89,0,0,1,2.57-7,14.26,14.26,0,0,1,5.44-5.1,14.87,14.87,0,0,1,7.32-1.6,18.91,18.91,0,0,1,7.29,1.76,17.4,17.4,0,0,1,6.07,4.45,6.12,6.12,0,0,1,1.6,3.59,2.83,2.83,0,0,1-.78,2,4.3,4.3,0,0,1-1.77,1.08,3.28,3.28,0,0,1-2.1-.09,5.22,5.22,0,0,1-1.7-1.11,10.93,10.93,0,0,1-2.2-3.15,22.22,22.22,0,0,1-2-7.25,26.49,26.49,0,0,1,.23-7.49,20.22,20.22,0,0,1,7.42-12.74,19.21,19.21,0,0,1,6.7-3.32,19.42,19.42,0,0,1,7.43-.48,26.15,26.15,0,0,1,7.14,2,29.89,29.89,0,0,1,6.39,3.7A29.77,29.77,0,0,0,333,84.42a18.83,18.83,0,0,0-7.21.6,18.81,18.81,0,0,0-11,8.79,21.46,21.46,0,0,0-2.35,6.8,24.58,24.58,0,0,0,1.73,14.15,10.06,10.06,0,0,0,2,2.89,3,3,0,0,0,2.88,1,3.32,3.32,0,0,0,1.36-.83,1.86,1.86,0,0,0,.53-1.35,5.25,5.25,0,0,0-1.38-3,16.52,16.52,0,0,0-5.73-4.23,18.69,18.69,0,0,0-7-1.74,14.34,14.34,0,0,0-7,1.41,13.7,13.7,0,0,0-5.31,4.77A18.39,18.39,0,0,0,291.86,127.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,381.92a4.25,4.25,0,1,0,2.78,5.34A4.26,4.26,0,0,0,175.87,381.92Zm2.29,5.18a3.73,3.73,0,1,1-2.44-4.68A3.74,3.74,0,0,1,178.16,387.1Zm-2.29-5.18a4.25,4.25,0,1,0,2.78,5.34A4.26,4.26,0,0,0,175.87,381.92Zm2.29,5.18a3.73,3.73,0,1,1-2.44-4.68A3.74,3.74,0,0,1,178.16,387.1Zm-2.29-5.18a4.25,4.25,0,1,0,2.78,5.34A4.26,4.26,0,0,0,175.87,381.92Zm2.29,5.18a3.73,3.73,0,1,1-2.44-4.68A3.74,3.74,0,0,1,178.16,387.1Zm-.87-9.67a9,9,0,1,0,5.85,11.24A9,9,0,0,0,177.29,377.43Zm2,10a4.91,4.91,0,1,1-3.21-6.16A4.91,4.91,0,0,1,179.28,387.45Zm-.63-.19a4.25,4.25,0,1,0-5.33,2.77A4.26,4.26,0,0,0,178.65,387.26Zm-.49-.16a3.73,3.73,0,1,1-2.44-4.68A3.74,3.74,0,0,1,178.16,387.1Zm-2.29-5.18a4.25,4.25,0,1,0,2.78,5.34A4.26,4.26,0,0,0,175.87,381.92Zm2.29,5.18a3.73,3.73,0,1,1-2.44-4.68A3.74,3.74,0,0,1,178.16,387.1Zm-2.29-5.18a4.25,4.25,0,1,0,2.78,5.34A4.26,4.26,0,0,0,175.87,381.92Zm2.29,5.18a3.73,3.73,0,1,1-2.44-4.68A3.74,3.74,0,0,1,178.16,387.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.66 394.69 170.37 393.65 169.82 396.04 172.74 396.96 173.66 394.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.75 391.61 166.16 388.55 164.08 389.85 165.5 392.57 167.75 391.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.75 385.26 166.79 381.97 164.4 381.42 163.48 384.34 165.75 385.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.83 379.35 171.88 377.76 170.59 375.68 167.87 377.1 168.83 379.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.18 377.35 178.47 378.38 179.02 376 176.1 375.08 175.18 377.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.09 380.43 182.68 383.48 184.76 382.19 183.34 379.47 181.09 380.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.09 386.78 182.05 390.07 184.44 390.62 185.36 387.7 183.09 386.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.01 392.69 176.95 394.28 178.25 396.36 180.97 394.94 180.01 392.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.67,353.35a13.7,13.7,0,1,0-19.16,2.84A13.7,13.7,0,0,0,341.67,353.35ZM335.81,349a6.4,6.4,0,1,1-1.32-8.95A6.39,6.39,0,0,1,335.81,349Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.96 357.3 320.73 354.16 318.75 357.33 322.51 360.12 324.96 357.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.97 349.9 317.2 344.69 313.55 345.52 314.24 350.16 317.97 349.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.26 339.72 321.4 335.49 318.23 333.5 315.44 337.26 318.26 339.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.66 332.73 330.87 331.96 330.04 328.31 325.4 329 325.66 332.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.84 333.01 340.07 336.15 342.05 332.99 338.29 330.19 335.84 333.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.83 340.42 343.6 345.63 347.25 344.79 346.56 340.16 342.83 340.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.54 350.59 339.4 354.82 342.57 356.81 345.36 353.05 342.54 350.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.14 357.59 329.93 358.36 330.76 362 335.4 361.32 335.14 357.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.77,345.84l2.91,3.67,4.63-.69,1.72-4.35-2.91-3.67-4.63.69Zm5.51-1.87a1.48,1.48,0,1,1-1.77,2.38,1.49,1.49,0,0,1-.3-2.08A1.47,1.47,0,0,1,331.28,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.94,86.6a3.72,3.72,0,1,0,2.43,4.67A3.71,3.71,0,0,0,351.94,86.6Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.27,3.27,0,0,1,353.94,91.13Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.67A3.71,3.71,0,0,0,351.94,86.6Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.27,3.27,0,0,1,353.94,91.13Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.67A3.71,3.71,0,0,0,351.94,86.6Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.27,3.27,0,0,1,353.94,91.13Zm-.76-8.46a7.84,7.84,0,1,0,5.12,9.84A7.85,7.85,0,0,0,353.18,82.67Zm1.74,8.77a4.3,4.3,0,1,1-2.8-5.39A4.3,4.3,0,0,1,354.92,91.44Zm-.55-.17a3.72,3.72,0,1,0-4.66,2.43A3.72,3.72,0,0,0,354.37,91.27Zm-.43-.14a3.27,3.27,0,1,1-2.13-4.1A3.27,3.27,0,0,1,353.94,91.13Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.67A3.71,3.71,0,0,0,351.94,86.6Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.27,3.27,0,0,1,353.94,91.13Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.67A3.71,3.71,0,0,0,351.94,86.6Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.27,3.27,0,0,1,353.94,91.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350 97.77 347.13 96.87 346.64 98.95 349.2 99.76 350 97.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.83 95.08 343.44 92.4 341.63 93.54 342.86 95.92 344.83 95.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.08 89.52 343.99 86.64 341.9 86.16 341.1 88.72 343.08 89.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.78 84.35 348.45 82.96 347.32 81.14 344.94 82.38 345.78 84.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.34 82.6 354.21 83.5 354.7 81.42 352.14 80.61 351.34 82.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.51 85.29 357.9 87.97 359.72 86.83 358.48 84.45 356.51 85.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.26 90.85 357.35 93.73 359.44 94.21 360.24 91.65 358.26 90.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.56 96.02 352.89 97.42 354.02 99.23 356.4 97.99 355.56 96.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.73,229.47a3.72,3.72,0,1,0,2.43,4.66A3.72,3.72,0,0,0,313.73,229.47Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.26,3.26,0,0,1,315.72,234Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.66A3.72,3.72,0,0,0,313.73,229.47Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.26,3.26,0,0,1,315.72,234Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.66A3.72,3.72,0,0,0,313.73,229.47Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.26,3.26,0,0,1,315.72,234Zm-.75-8.47a7.84,7.84,0,1,0,5.12,9.84A7.85,7.85,0,0,0,315,225.53Zm1.74,8.78a4.3,4.3,0,1,1-2.81-5.39A4.3,4.3,0,0,1,316.71,234.31Zm-.55-.18a3.72,3.72,0,1,0-4.67,2.43A3.72,3.72,0,0,0,316.16,234.13Zm-.44-.13a3.27,3.27,0,1,1-2.13-4.1A3.26,3.26,0,0,1,315.72,234Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.66A3.72,3.72,0,0,0,313.73,229.47Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.26,3.26,0,0,1,315.72,234Zm-2-4.53a3.72,3.72,0,1,0,2.43,4.66A3.72,3.72,0,0,0,313.73,229.47Zm2,4.53a3.27,3.27,0,1,1-2.13-4.1A3.26,3.26,0,0,1,315.72,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.79 240.64 308.91 239.73 308.43 241.82 310.99 242.62 311.79 240.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.62 237.94 305.23 235.27 303.41 236.4 304.65 238.78 306.62 237.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.87 232.38 305.77 229.51 303.69 229.03 302.88 231.58 304.87 232.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.56 227.21 310.24 225.82 309.1 224 306.72 225.24 307.56 227.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.12 225.46 316 226.37 316.48 224.28 313.92 223.48 313.12 225.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.29 228.16 319.68 230.83 321.5 229.7 320.26 227.32 318.29 228.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.04 233.72 319.13 236.59 321.22 237.08 322.03 234.52 320.04 233.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.35 238.89 314.67 240.28 315.81 242.1 318.19 240.86 317.35 238.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,117a11.79,11.79,0,1,0-14.25,8.67A11.8,11.8,0,0,0,95,117Zm-6.11-1.49a5.51,5.51,0,1,1-4-6.65A5.5,5.5,0,0,1,88.91,115.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.09 125.72 78.68 124.65 78.17 127.83 82.08 128.78 83.09 125.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.06 122.19 72.7 118.32 70.09 120.2 72.19 123.65 75.06 122.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.88 114.02 72.95 109.62 69.78 109.1 68.82 113.02 71.88 114.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.41 106 79.28 103.64 77.4 101.03 73.96 103.13 75.41 106",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.58 102.82 87.99 103.89 88.5 100.71 84.58 99.76 83.58 102.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.61 106.35 93.96 110.22 96.58 108.34 94.48 104.89 91.61 106.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.79 114.52 93.71 118.92 96.89 119.44 97.85 115.52 94.79 114.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.26 122.54 87.38 124.9 89.27 127.51 92.71 125.42 91.26 122.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.89,116.37l3.54,1.93,3.44-2.1-.09-4-3.54-1.94-3.44,2.09ZM83.64,113a1.28,1.28,0,1,1-1.55.94A1.29,1.29,0,0,1,83.64,113Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.59,238.94a24.58,24.58,0,0,1-4.2-13.58c0-17.19,18.88-31.13,42.16-31.13s42.14,13.94,42.14,31.13-18.86,31.14-42.14,31.14c-11.29,0-21.52-3.27-29.08-8.61L356,251.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,238.94a24,24,0,0,1-.94-26,33,33,0,0,1,9.27-10.06,43.87,43.87,0,0,1,12.23-6.23A57.17,57.17,0,0,1,395.62,194a58.39,58.39,0,0,1,13.72.7c1.13.23,2.27.38,3.38.68l3.33.9,3.25,1.14c1.08.39,2.11.92,3.17,1.37a41,41,0,0,1,11.32,7.83,28.92,28.92,0,0,1,7.29,11.68,23.71,23.71,0,0,1,.14,13.76,28.74,28.74,0,0,1-7.11,11.79,40.4,40.4,0,0,1-11.22,8,49.49,49.49,0,0,1-13.1,4.2,57.79,57.79,0,0,1-13.71.78,53.82,53.82,0,0,1-13.48-2.56,45.26,45.26,0,0,1-12.26-6.12l.18,0L356,251.69l-.22.05.1-.2Zm0,0-5.54,12.68-.13-.15,14.49-3.8.1,0,.09.06A49.68,49.68,0,0,0,396.12,256a56.68,56.68,0,0,0,13.52-.89A48.74,48.74,0,0,0,422.5,251a39.59,39.59,0,0,0,10.95-7.82,27.66,27.66,0,0,0,6.84-11.41,22.71,22.71,0,0,0-.16-13.19,27.86,27.86,0,0,0-7-11.3,39.74,39.74,0,0,0-11-7.68c-1-.44-2-1-3.11-1.35l-3.19-1.14-3.27-.89c-1.09-.29-2.21-.45-3.32-.68a58.83,58.83,0,0,0-13.52-.74,55.85,55.85,0,0,0-13.3,2.54,43.43,43.43,0,0,0-12.11,6,33.34,33.34,0,0,0-9.24,9.8,24.28,24.28,0,0,0-3.51,12.95A24.68,24.68,0,0,0,361.59,238.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.86,230.46v2.32h-9.43V219.19h9.26v2.32h-6.62v3.27h5.72v2.14h-5.72v3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.93,232.78V219.19h6a3.88,3.88,0,0,1,1.73.39,4.56,4.56,0,0,1,1.37,1,4.91,4.91,0,0,1,.9,1.45,4.56,4.56,0,0,1-.34,4,3.77,3.77,0,0,1-1.79,1.56l3.1,5.11h-3l-2.78-4.56h-2.6v4.56Zm2.64-6.87h3.31a1.46,1.46,0,0,0,.68-.17,1.89,1.89,0,0,0,.55-.47,2.43,2.43,0,0,0,.36-.7,2.71,2.71,0,0,0,.13-.86,2.5,2.5,0,0,0-.15-.88,2.31,2.31,0,0,0-.41-.7,1.85,1.85,0,0,0-.59-.46,1.54,1.54,0,0,0-.68-.16h-3.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,232.78V219.19h6a3.9,3.9,0,0,1,1.74.39,4.65,4.65,0,0,1,1.36,1,4.53,4.53,0,0,1,.9,1.45,4.33,4.33,0,0,1,.33,1.64,4.51,4.51,0,0,1-.66,2.4,3.81,3.81,0,0,1-1.79,1.56l3.1,5.11h-3l-2.77-4.56h-2.6v4.56Zm2.65-6.87h3.31a1.46,1.46,0,0,0,.68-.17,1.73,1.73,0,0,0,.54-.47,2.21,2.21,0,0,0,.36-.7,2.72,2.72,0,0,0,.14-.86,2.5,2.5,0,0,0-.15-.88,2.33,2.33,0,0,0-.42-.7,1.85,1.85,0,0,0-.59-.46,1.51,1.51,0,0,0-.68-.16H395.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.18,232.87a6.15,6.15,0,0,1-2.71-.58,6.55,6.55,0,0,1-2.08-1.55,6.85,6.85,0,0,1-1.35-2.21,7,7,0,0,1-.48-2.55,6.81,6.81,0,0,1,.51-2.6,7.09,7.09,0,0,1,1.39-2.2,6.74,6.74,0,0,1,2.12-1.52,6.19,6.19,0,0,1,2.66-.56,6,6,0,0,1,2.69.6,6.63,6.63,0,0,1,2.07,1.58,7.16,7.16,0,0,1,1.34,2.22,6.93,6.93,0,0,1,0,5.12A7.12,7.12,0,0,1,416,230.8a6.72,6.72,0,0,1-2.11,1.51A6.22,6.22,0,0,1,411.18,232.87ZM407.24,226a5.76,5.76,0,0,0,.26,1.71,4.5,4.5,0,0,0,.78,1.45,4,4,0,0,0,1.24,1,3.68,3.68,0,0,0,1.68.38,3.54,3.54,0,0,0,1.69-.39,3.84,3.84,0,0,0,1.25-1.05,4.72,4.72,0,0,0,.76-1.46,5.48,5.48,0,0,0,.26-1.66,5.18,5.18,0,0,0-.28-1.7,4.5,4.5,0,0,0-.78-1.45,3.74,3.74,0,0,0-1.25-1,3.88,3.88,0,0,0-3.35,0,3.73,3.73,0,0,0-1.25,1,4.54,4.54,0,0,0-.75,1.45A5.17,5.17,0,0,0,407.24,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.85,232.78V219.19h6a3.88,3.88,0,0,1,1.73.39,4.56,4.56,0,0,1,1.37,1,4.91,4.91,0,0,1,.9,1.45,4.56,4.56,0,0,1-.34,4,3.77,3.77,0,0,1-1.79,1.56l3.1,5.11h-3l-2.78-4.56h-2.6v4.56Zm2.64-6.87h3.31a1.46,1.46,0,0,0,.68-.17,1.89,1.89,0,0,0,.55-.47,2.43,2.43,0,0,0,.36-.7,2.71,2.71,0,0,0,.13-.86,2.5,2.5,0,0,0-.15-.88,2.31,2.31,0,0,0-.41-.7,1.85,1.85,0,0,0-.59-.46,1.54,1.54,0,0,0-.68-.16h-3.2Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops404ErrorwithabrokenrobotCuate);
export default __webpack_public_path__ + "static/media/Oops 404 Error with a broken robot-cuate.295434f10f0117f4e0b7daa11a4fcfd9.svg";
export { ForwardRef as ReactComponent };